import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxDirective } from './checkbox.directive';
import { CheckboxLabelDirective } from './checkbox-label/checkbox-label.directive';
import { CheckboxComponent } from './checkbox.component';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [CheckboxDirective, CheckboxLabelDirective, CheckboxComponent],
  imports: [CommonModule, TooltipModule],
  exports: [CheckboxDirective, CheckboxLabelDirective, CheckboxComponent],
})
export class CheckboxModule {}
